import React from 'react';
import { CONFIG } from 'src/model/config';

export const MainLogo = () => (
  <div style={{padding: '16px'}} className='logo'>
    <img src={CONFIG.IMAGE_LOGO} alt={CONFIG.UNIVERSITY_NAME} />
  </div>
);
